import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-host-stats',
  templateUrl: './host-stats.component.html',
  styleUrls: ['./host-stats.component.css']
})
export class HostStatsComponent implements OnInit {

  @Input() hideButton: boolean = false;

  statsObject: HostStats;
  loading: boolean = true;
  err: string = '';

  constructor(private userService: UserService, private router: Router) { }

  ngOnInit(): void {
    this.userService.getUserStats()
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe(
        (stats: HostStats) => {
          this.statsObject = stats;
        },
        (error) => {
          console.error('Error fetching host stats:', error);
          this.err = "Unable to retrieve stats";
        })
  }

  getLastHostDate() {
    if (this.statsObject && this.statsObject.last_hosted_on) {
      const lastHostDate = new Date(this.statsObject.last_hosted_on);
      return lastHostDate.toLocaleDateString();
    }
    return 'N/A';
  }

  toProfile() {
    this.router.navigate(['/profile']);
  }

}
